import { useState, useEffect } from "react";
import { getListSection, deleteSection } from '../../../store/index.service';
import { useNavigate } from "react-router-dom";
import { HeaderList } from '../../../components/HeaderList/HeaderList';
import { Breadcrumb } from '../../../components/Breadcrumb/Breadcrumb';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTableColumns, faTrash } from '@fortawesome/free-solid-svg-icons'
import { DataGridPro, GridActionsCellItem, GridToolbarContainer, GridToolbarFilterButton } from '@mui/x-data-grid-pro';
import { Popup } from "../../../components/Popup/Popup";
import { CreateSection } from "../../../components/Popup/section/CreateSection";
import { ConfirmDelete } from "../../../components/Popup/content/ConfirmDelete";
import { Button } from "@mui/material";

const CustomToolbar = () => {
    return (
        <GridToolbarContainer>
            <GridToolbarFilterButton />
        </GridToolbarContainer>
    );
}

export const Section = () => {

    const [listSection, setListSection] = useState({loading: true, data: [] });
    const [showPopupConfirmDelete, setShowPopupConfirmDelete] = useState({show: false});
    const [showPopupCreateSection, setShowPopupCreateSection] = useState({show: false});

    const columns = [
        { field: 'template', headerName: 'Template', flex: 1.5 },
        { field: 'title', headerName: 'Titre', flex: 1.5, valueGetter: (params) => params.row.fr.title.data },
        { field: 'actions', type: "actions", flex: 0.4, getActions: (params) => [
            <GridActionsCellItem
                icon={<FontAwesomeIcon icon={faTrash} size="1x" />}
                onClick={() => setShowPopupConfirmDelete({ show: true, id: params.row.id })}
                label="Supprimer"
            />
        ] }
    ];

    useEffect(() => {
        handleGetData();
    }, []);

    const handleGetData = () => {
        getListSection().then(res => {
            setListSection({
                loading: false,
                data: res ?? []
            });
        });
    }  

    const handleDelete = () => {
        deleteSection(showPopupConfirmDelete.id).then(() => {
            handleGetData();
        });
    }

    return (
        <div className="list">

            <HeaderList title="Templates sections" icon={faTableColumns}>
                <Button variant="contained" onClick={() => setShowPopupCreateSection({ show: true })}>Créer une section</Button>
            </HeaderList>

            <Breadcrumb
                links={[
                    { label: "Templates" },
                    { label: "Sections" }
                ]}
            />

            <DataGridPro
                autoHeight
                rows={listSection.data}
                columns={columns}
                pageSize={20}
                className="table"
                loading={listSection.loading}
                pagination
                pageSizeOptions={[20, 50, 100]}
                slots={{
                    toolbar: CustomToolbar,
                }}
            />

            { showPopupConfirmDelete.show &&
                <Popup
                    closePopup={() => setShowPopupConfirmDelete({ show: false })}
                    customContent={true}
                >
                    <ConfirmDelete msg={"cette section"} handleDelete={handleDelete} />
                </Popup>
            }

            { showPopupCreateSection.show &&
                <Popup
                    closePopup={() => setShowPopupCreateSection({ show: false })}
                    customContent={true}
                >
                    <CreateSection 
                        closePopup={() => setShowPopupCreateSection({ show: false })}
                        refreshData={() => handleGetData()} 
                    />
                </Popup>
            }

        </div>
    )
}